export default __webpack_public_path__ + "static/media/card-failure-dark.6c03f93e.svg";